export default __webpack_public_path__ + "static/media/A0.d9eccb79.mp3";